import { sessionListSearchValueAtom } from '@/atoms/sideNavAtoms';
import { SESSION_SEARCH_DEBOUNCE_MS } from '@/components/layout/Navigation/sessions/constants';
import { useDebounce } from '@uidotdev/usehooks';
import { useAtomValue } from 'jotai';

export const useDebouncedSessionSearchValue = () => {
  const searchValue = useAtomValue(sessionListSearchValueAtom);
  return useDebounce(searchValue, SESSION_SEARCH_DEBOUNCE_MS);
};
